var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('layout',[_c('template',{slot:"title"},[_c('span',{domProps:{"innerHTML":_vm._s(_vm.helpTitle)}})]),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12"},[_c('div',{domProps:{"innerHTML":_vm._s(_vm.helpDescription)}})])])],2)}
var staticRenderFns = []

export { render, staticRenderFns }